import { lazy } from "react"
import { canCurrentUserWrite } from "../assets/js/app/state/appSessionStorage"
import { RoutePaths } from "./RoutePaths"
import { USER_ROLES } from "./routesState"

const AllRoutes = () => {
  return [
    {
      exact: true,
      path: RoutePaths.DASHBOARD,
      permission: ["*"],
      component: lazy(() => import("../assets/js/pages/dashboard/Dashboard"))
    },
    // user
    {
      exact: true,
      path: RoutePaths.USERS,
      permission: [
        USER_ROLES.SUPER_ADMIN,
        USER_ROLES.TENANT_ADMIN,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.CLAIM_MANAGER
      ],
      component: lazy(() => import("../assets/js/pages/user/UsersPage"))
    },
    {
      exact: true,
      path: RoutePaths.USER_NEW,
      permission: canCurrentUserWrite()
        ? [
          USER_ROLES.SUPER_ADMIN,
          USER_ROLES.TENANT_ADMIN,
          USER_ROLES.ORGANIZATION_ADMIN,
          USER_ROLES.CLAIM_MANAGER
        ]
        : null,
      component: lazy(() => import("../assets/js/pages/user/UserNewPage"))
    },
    {
      exact: true,
      path: RoutePaths.USER_EDIT,
      permission: canCurrentUserWrite()
        ? [
          USER_ROLES.SUPER_ADMIN,
          USER_ROLES.TENANT_ADMIN,
          USER_ROLES.ORGANIZATION_ADMIN,
          USER_ROLES.CLAIM_MANAGER,
          USER_ROLES.CLAIMANT
        ]
        : null,
      component: lazy(() => import("../assets/js/pages/user/UserEditPage"))
    },
    {
      exact: true,
      path: RoutePaths.USER,
      permission: [USER_ROLES.ALL],
      component: lazy(() => import("../assets/js/pages/user/UserPage"))
    },

    // tenant
    {
      exact: true,
      path: RoutePaths.TENANTS,
      permission: [USER_ROLES.SUPER_ADMIN],
      component: lazy(() => import("../assets/js/pages/tenant/TenantsPage"))
    },
    {
      exact: true,
      path: RoutePaths.TENANT_NEW,
      permission: canCurrentUserWrite() ? [USER_ROLES.SUPER_ADMIN] : null,
      component: lazy(() => import("../assets/js/pages/tenant/TenantNewPage"))
    },
    {
      exact: true,
      path: RoutePaths.TENANT_EDIT,
      permission: canCurrentUserWrite() ? [USER_ROLES.SUPER_ADMIN] : null,
      component: lazy(() => import("../assets/js/pages/tenant/TenantEditPage"))
    },
    {
      exact: true,
      path: RoutePaths.TENANT,
      permission: [USER_ROLES.SUPER_ADMIN],
      component: lazy(() => import("../assets/js/pages/tenant/TenantPage"))
    },
    {
      exact: true,
      path: RoutePaths.TENANT_IMAGE,
      permission: [USER_ROLES.TENANT_ADMIN],
      component: lazy(() => import("../assets/js/pages/tenant/TenantImagePage"))
    },

    // org
    {
      exact: true,
      path: RoutePaths.ORGANIZATIONS,
      permission: [USER_ROLES.TENANT_ADMIN, USER_ROLES.ORGANIZATION_ADMIN],
      component: lazy(
        () => import("../assets/js/pages/organization/OrganizationsPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.ORGANIZATION_NEW,
      permission: canCurrentUserWrite()
        ? [USER_ROLES.TENANT_ADMIN, USER_ROLES.ORGANIZATION_ADMIN]
        : null,
      component: lazy(
        () => import("../assets/js/pages/organization/OrganizationNewPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.ORGANIZATION_EDIT,
      permission: canCurrentUserWrite()
        ? [USER_ROLES.TENANT_ADMIN, USER_ROLES.ORGANIZATION_ADMIN]
        : null,
      component: lazy(
        () => import("../assets/js/pages/organization/OrganizationEditPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.ORGANIZATION,
      permission: [USER_ROLES.TENANT_ADMIN, USER_ROLES.ORGANIZATION_ADMIN],
      component: lazy(
        () => import("../assets/js/pages/organization/OrganizationPage")
      )
    },

    // appointment
    {
      exact: true,
      path: RoutePaths.APPOINTMENTS,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ],
      component: lazy(
        () => import("../assets/js/pages/appointment/AppointmentsPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.APPOINTMENT,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ],
      component: lazy(
        () => import("../assets/js/pages/appointment/AppointmentPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.APPOINTMENT_NEW,
      permission: canCurrentUserWrite() ? [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ] : null,
      component: lazy(
        () => import("../assets/js/pages/appointment/AppointmentNewPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.APPOINTMENT_EDIT,
      permission: canCurrentUserWrite() ? [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ] : null,
      component: lazy(
        () => import("../assets/js/pages/appointment/AppointmentEditPage")
      )
    },

    // USE CASE
    {
      exact: true,
      path: RoutePaths.USE_CASE,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.EMPLOYER
      ],

      component: lazy(() => import("../assets/js/pages/UseCase/UseCaseListing"))
    },
    {
      exact: true,
      path: RoutePaths.USE_CASE_CASES,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.EMPLOYER
      ],

      component: lazy(() => import("../assets/js/pages/UseCase/UseCaseListingCases"))
    },
    {
      exact: true,
      path: RoutePaths.USE_CASE_CLAIMS,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.EMPLOYER
      ],

      component: lazy(() => import("../assets/js/pages/UseCase/UseCaseListingClaims"))
    },
    {
      exact: true,
      path: RoutePaths.USE_CASE_CREATE,
      permission: canCurrentUserWrite() ? [USER_ROLES.CLAIM_MANAGER, USER_ROLES.ORGANIZATION_ADMIN] : null,
      component: lazy(() => import("../assets/js/pages/UseCase/UseCaseCreate"))
    },
    {
      exact: true,
      path: RoutePaths.USE_CASE_DETAILS,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ],
      component: lazy(
        () => import("../assets/js/pages/UseCase/UseCaseDetails")
      )
    },
    {
      exact: true,
      path: RoutePaths.USE_CASE_EDIT,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ],
      component: lazy(
        () => import("../assets/js/pages/UseCase/UseCaseEdit")
      )
    },
    {
      exact: true,
      path: RoutePaths.USE_CASE_NOTES,
      permission: [
        USER_ROLES.CLAIM_MANAGER
      ],
      component: lazy(() => import("../assets/js/pages/UseCase/UseCaseDetails/UseCaseNotesAdminPage"))
    },

    // Claim
    {
      exact: true,
      path: RoutePaths.CLAIMS,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.EMPLOYER
      ],

      component: lazy(() => import("../assets/js/pages/claim/ClaimsPage"))
    },
    {
      exact: true,
      path: RoutePaths.CLAIM_NEW,
      permission: canCurrentUserWrite() ? [USER_ROLES.CLAIM_MANAGER, USER_ROLES.ORGANIZATION_ADMIN] : null,
      component: lazy(() => import("../assets/js/pages/claim/ClaimNewPage"))
    },
    {
      exact: true,
      path: RoutePaths.CLAIM_CLINICAL,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ],
      component: lazy(
        () => import("../assets/js/pages/claim/ClaimClinicalPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.CLAIM_CLINICAL_EDIT,
      permission: canCurrentUserWrite()
        ? [
          USER_ROLES.CLAIM_MANAGER,
          USER_ROLES.CLAIMANT,
          USER_ROLES.REHAB_MANAGER,
          USER_ROLES.EMPLOYER
        ]
        : null,
      component: lazy(
        () => import("../assets/js/pages/claim/editPage/ClaimClinicalEditPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.CLAIM_INJURY,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.CLAIMANT,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ],
      component: lazy(() => import("../assets/js/pages/claim/ClaimInjuryPage"))
    },
    {
      exact: true,
      path: RoutePaths.CLAIM_INJURY_NOTES,
      permission: [
        USER_ROLES.CLAIM_MANAGER
      ],
      component: lazy(() => import("../assets/js/pages/claim/ClaimInjuryNotesPage"))
    },
    {
      exact: true,
      path: RoutePaths.CLAIM_INJURY_EDIT,
      permission: canCurrentUserWrite() ? [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.CLAIMANT,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ] : null,
      component: lazy(
        () => import("../assets/js/pages/claim/editPage/ClaimInjuryEditPage")
      )
    },

    // Chat
    {
      exact: true,
      path: RoutePaths.CHATS,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ],
      component: lazy(() => import("../assets/js/pages/chat/ChatsPage"))
    },
    {
      exact: true,
      path: RoutePaths.GROUP_CHAT_NEW,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ],
      component: lazy(
        () => import("../assets/js/pages/chat/ChatsGroupNewPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.GROUP_CHAT,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ],
      component: lazy(() => import("../assets/js/pages/chat/GroupChatInfo"))
    },

    // RECOVERY PROGRESS
    {
      exact: true,
      path: RoutePaths.RECOVERY_PROGRESSES,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER,
        USER_ROLES.ORGANIZATION_ADMIN
      ],
      component: lazy(
        () =>
          import("../assets/js/pages/recoveryProgress/RecoveryProgressesPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.RECOVERY_PROGRESS,
      permission: [
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER,
        USER_ROLES.ORGANIZATION_ADMIN
      ],
      component: lazy(
        () => import("../assets/js/pages/recoveryProgress/RecoveryProgressPage")
      )
    },

    // report
    {
      exact: true,
      path: RoutePaths.REPORT,
      permission: [
        USER_ROLES.SUPER_ADMIN,
        USER_ROLES.TENANT_ADMIN,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.CLAIM_MANAGER,
        USER_ROLES.CLAIMANT,
        USER_ROLES.REHAB_MANAGER,
        USER_ROLES.EMPLOYER
      ],
      component: lazy(() => import("../assets/js/pages/report/ReportsPage"))
    },
    // report
    {
      exact: true,
      path: RoutePaths.TRACKING_REPORT,
      permission: [
        USER_ROLES.SUPER_ADMIN
      ],
      component: lazy(() => import("../assets/js/pages/report/TrackingReport/TrackingReportPage"))
    },
    // survey
    {
      exact: true,
      path: RoutePaths.SURVEY_PROCESS,
      permission: [USER_ROLES.CLAIMANT],
      component: lazy(
        () => import("../assets/js/pages/survey/process/SurveyProcessesPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_PROCESS_EXECUTION,
      permission: [USER_ROLES.CLAIMANT],
      component: lazy(
        () =>
          import("../assets/js/pages/survey/process/SurveyProcessExecutionPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_PROCESS_EXECUTION_HISTORY,
      permission: [USER_ROLES.CLAIMANT],
      component: lazy(
        () =>
          import(
            "../assets/js/pages/survey/process/SurveyProcessExecutionHistoryPage"
          )
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_DASHBOARD,
      permission: [USER_ROLES.TENANT_ADMIN],
      component: lazy(
        () => import("../assets/js/pages/survey/SurveyDashBoardPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_QUESTIONNAIRES,
      permission: [USER_ROLES.TENANT_ADMIN],
      component: lazy(
        () => import("../assets/js/pages/survey/questionary/QuestionnairesPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_QUESTIONNAIRE,
      permission: [USER_ROLES.TENANT_ADMIN],
      component: lazy(
        () => import("../assets/js/pages/survey/questionary/QuestionnairePage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_QUESTIONNAIRE_NEW,
      permission: [USER_ROLES.TENANT_ADMIN],
      component: lazy(
        () => import("../assets/js/pages/survey/questionary/QuestionaryNewPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_QUESTIONNAIRE_EDIT,
      permission: [USER_ROLES.TENANT_ADMIN],
      component: lazy(
        () =>
          import("../assets/js/pages/survey/questionary/QuestionaryEditPage")
      )
    },

    {
      exact: true,
      path: RoutePaths.SURVEY_GROUPS,
      permission: [],
      component: lazy(
        () => import("../assets/js/pages/survey/group/SurveyGroupsPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_GROUP_NEW,
      permission: [],
      component: lazy(
        () => import("../assets/js/pages/survey/group/SurveyGroupNewPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_GROUP,
      permission: [],
      component: lazy(
        () => import("../assets/js/pages/survey/group/SurveyGroupPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_GROUP_EDIT,
      permission: [],
      component: lazy(
        () => import("../assets/js/pages/survey/group/SurveyGroupEditPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_GROUP_EDIT_QUESTIONNAIRE,
      permission: [],
      component: lazy(
        () =>
          import(
            "../assets/js/pages/survey/group/SurveyGroupUpdateQuestionnaires"
          )
      )
    },

    // survey events
    {
      exact: true,
      path: RoutePaths.SURVEY_EVENTS,
      permission: [USER_ROLES.TENANT_ADMIN],
      component: lazy(
        () => import("../assets/js/pages/survey/event/SurveyEventsPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_EVENT_NEW,
      permission: [USER_ROLES.TENANT_ADMIN],
      component: lazy(
        () => import("../assets/js/pages/survey/event/SurveyEventNewPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_EVENT,
      permission: [USER_ROLES.TENANT_ADMIN],
      component: lazy(
        () => import("../assets/js/pages/survey/event/SurveyEventPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_EVENT_EDIT,
      permission: [USER_ROLES.TENANT_ADMIN],
      component: lazy(
        () => import("../assets/js/pages/survey/event/SurveyEventEditPage")
      )
    },
    // survey report
    {
      exact: true,
      path: RoutePaths.SURVEY_REPORT,
      permission: [USER_ROLES.TENANT_ADMIN],
      component: lazy(
        () => import("../assets/js/pages/survey/report/SurveyReportsPage")
      )
    },
    {
      exact: true,
      path: RoutePaths.SURVEY_REPORT_BY_QUESTION,
      permission: [USER_ROLES.TENANT_ADMIN],
      component: lazy(
        () => import("../assets/js/pages/survey/report/SurveyReportByQuestion")
      )
    },
    {
      exact: true,
      path: RoutePaths.BULK_UPLOAD,
      permission: [
        USER_ROLES.SUPER_ADMIN,
        USER_ROLES.TENANT_ADMIN,
        USER_ROLES.ORGANIZATION_ADMIN,
        USER_ROLES.CLAIM_MANAGER
      ],
      component: lazy(
        () => import("../assets/js/pages/bulkUpload/BulkUpload")
      )
    },

    // DEFAULT
    {
      exact: true,
      path: RoutePaths.PAGE_NOT_FOUND,
      permission: [USER_ROLES.ALL],
      component: lazy(() => import("../assets/js/pages/error/PageNotFound"))
    },
    {
      exact: true,
      path: "/error",
      permission: [USER_ROLES.ALL],
      component: lazy(() => import("../assets/js/pages/error/Error"))
    }
    // {
    //   path: "*",
    //   exact: true,
    //   permission: [USER_ROLES.ALL],
    //   component: () => <Redirect to={RoutePaths.PAGE_NOT_FOUND} />
    // }
  ]
}

export default AllRoutes
